import { render, staticRenderFns } from "./Portfolio_openpositions.vue?vue&type=template&id=5de8df8a&scoped=true&"
import script from "./Portfolio_openpositions.vue?vue&type=script&lang=js&"
export * from "./Portfolio_openpositions.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_openpositions.vue?vue&type=style&index=0&id=5de8df8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8df8a",
  null
  
)

export default component.exports